import React from "react";

import { Alert } from "~/components/alert";
import { For } from "~/components/for";
import { useScope } from "~/tools/impulse";
import type { ImpulseFormList } from "~/tools/impulse-form";
import { splice } from "~/tools/splice";

import { SetupDashboardWidgetLink } from "./_link/field";
import { FormState } from "./_link/form-state";

export interface SetupDashboardWidgetLinksProps {
	links: ImpulseFormList<FormState>;
}

export const SetupDashboardWidgetLinks: React.FC<SetupDashboardWidgetLinksProps> = ({ links }) => {
	const scope = useScope();

	return (
		<div>
			<For
				className="space-y-4"
				each={links.getElements(scope)}
				el="ol"
				empty={
					<Alert variant="info">
						No links are configured for this widget yet. You can add relative (internal) or absolute (external) links to
						the widget.
					</Alert>
				}
			>
				{(link, index) => (
					<li key={index}>
						<SetupDashboardWidgetLink
							index={index}
							link={link}
							name={index === 0 ? "Primary link" : `Additional link #${index}`}
							onDelete={() => {
								links.setElements(splice(index, 1, []));
							}}
						/>
					</li>
				)}
			</For>

			<footer className="mt-6 flex flex-row gap-3">
				<button
					className="button button-secondary uppercase"
					onClick={() => {
						links.setElements((current) => [...current, FormState.init()]);
					}}
					type="button"
				>
					Add link
				</button>

				{links.isDirty(scope) && (
					<button className="button button-tertiary uppercase" onClick={() => links.reset()} type="button">
						Reset links
					</button>
				)}
			</footer>
		</div>
	);
};
